module.exports = __webpack_public_path__ + "img/loginPhone.8eb77355.svg";